import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое корпоративная академия?',
    a: 'Корпоративная академия — это система развития сотрудников внутри компании, которая включает диагностику компетенций, программы обучения, наставничество, базу знаний и регулярную оценку эффективности. В отличие от набора разовых тренингов, академия создаёт непрерывный цикл обучения, который работает без постоянного участия руководителя и привязан к бизнес-показателям.',
  },
  {
    q: 'Зачем нужна корпоративная академия?',
    a: 'Корпоративная академия решает ключевые бизнес-задачи: ускоряет адаптацию новых сотрудников, снижает текучесть персонала, стандартизирует работу, накапливает и передаёт внутренние знания, развивает руководителей и кадровый резерв, а также позволяет масштабировать бизнес без потери качества.',
  },
  {
    q: 'Чем корпоративная академия отличается от учебного центра?',
    a: 'Учебный центр — это место или платформа для проведения обучения. Корпоративная академия — это система, которая включает методологию, матрицу компетенций, образовательные программы, наставников, базу знаний и систему оценки. Учебный центр может быть частью академии, но академия — это гораздо больше, чем просто помещение или LMS.',
  },
  {
    q: 'Когда компании нужна корпоративная академия?',
    a: 'Когда компания быстро растёт, наблюдается высокая текучесть, много новичков, несколько филиалов, нет единых стандартов работы, сильная зависимость от отдельных сотрудников, сложный продукт или услуга, большой отдел продаж, постоянно появляются новые руководители, либо планируется масштабирование бизнеса.',
  },
  {
    q: 'Можно ли создать академию без LMS?',
    a: 'Да, на первых этапах LMS (Learning Management System) не является обязательным элементом. Главное — методология, стандарты, программы обучения, наставники и система оценки. Многие компании успешно запускают академию, используя Google Drive, чек-листы и очные сессии. LMS внедряется позже как удобный инструмент автоматизации.',
  },
  {
    q: 'Как обучать сотрудников внутри компании?',
    a: 'Через систему корпоративного обучения: определить необходимые компетенции для каждой роли, создать матрицу компетенций, разработать образовательные программы, подготовить внутренних тренеров и наставников, внедрить практическую отработку и регулярную оценку, создать базу знаний и обеспечить систематическое повторение и развитие.',
  },
  {
    q: 'Как организовать систему обучения персонала?',
    a: 'Поэтапно: 1) диагностика текущих компетенций и потребностей бизнеса, 2) описание матрицы компетенций по ролям, 3) проектирование архитектуры системы обучения, 4) создание учебных программ и материалов, 5) подготовка внутренних тренеров, 6) пилотный запуск, 7) сопровождение и 8) непрерывное развитие академии.',
  },
  {
    q: 'Что входит в корпоративную академию?',
    a: '12 ключевых элементов: онбординг новых сотрудников, академия продаж, школа руководителей, развитие Soft Skills, база знаний, наставничество, подготовка внутренних тренеров, электронное обучение, бизнес-игры, оценка компетенций, карьерные треки и индивидуальные планы развития. Набор элементов зависит от потребностей компании.',
  },
  {
    q: 'Кто отвечает за корпоративное обучение?',
    a: 'L&D-специалист (Learning & Development) или HR Business Partner координирует систему обучения. Однако ответственность за результат лежит на руководителях подразделений, которые должны поддерживать обучение, требовать применения новых навыков и участвовать в развитии своих сотрудников.',
  },
  {
    q: 'Сколько стоит создание корпоративной академии?',
    a: 'Стоимость зависит от размера компании, количества программ, глубины проработки и выбранного формата внедрения (под ключ или поэтапно). Это инвестиция, которая окупается через снижение текучести, ускорение адаптации и рост эффективности сотрудников. Точный расчёт предоставляется после диагностики.',
  },
  {
    q: 'Можно ли внедрить академию поэтапно?',
    a: 'Да, поэтапное внедрение — лучшая практика. Обычно начинают с онбординга и обучения отдела продаж (быстрый эффект), затем добавляют школу руководителей, потом развитие Soft Skills и базу знаний. Каждый этап приносит измеримые результаты, что помогает обосновать инвестиции в следующие этапы.',
  },
  {
    q: 'Как измерять эффективность корпоративной академии?',
    a: 'По ключевым метрикам: время адаптации новичков до выхода на KPI, текучесть персонала (особенно в первые 6-12 месяцев), выполнение бизнес-показателей, вовлечённость сотрудников (eNPS), скорость карьерного роста внутри компании, оценка компетенций до и после обучения, а также бизнес-показатели подразделений.',
  },
  {
    q: 'Чем отличается корпоративная академия от корпоративного университета?',
    a: 'Корпоративный университет — более масштабная структура, часто с собственным кампусом и академическими программами (как СберУниверситет). Корпоративная академия — практическая система обучения, ориентированная на бизнес-результат здесь и сейчас и подходящая для большинства компаний от 20 до 1000+ сотрудников.',
  },
  {
    q: 'Как обучать руководителей внутри компании?',
    a: 'Через школу руководителей — системную программу развития управленческих компетенций. Включает: тренинги по лидерству, делегированию, обратной связи и управлению конфликтами; бизнес-игры и симуляции; разбор реальных управленческих кейсов компании; коучинговые сессии и регулярную оценку прогресса.',
  },
  {
    q: 'Подходит ли корпоративная академия для малого бизнеса?',
    a: 'Да, но в адаптированном формате. Для компании от 20 сотрудников можно создать облегчённую версию академии: стандартизированный онбординг, база знаний, наставничество и регулярные обучающие сессии. Это помогает стандартизировать работу и снизить критическую зависимость от ключевых сотрудников.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Часто задаваемые вопросы о корпоративной академии
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о создании и развитии системы корпоративного обучения
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}